export var ListBoxItemType;
(function (ListBoxItemType) {
    ListBoxItemType[ListBoxItemType["Row"] = 1] = "Row";
    ListBoxItemType[ListBoxItemType["Header"] = 2] = "Header";
    ListBoxItemType[ListBoxItemType["Divider"] = 3] = "Divider";
    ListBoxItemType[ListBoxItemType["Loading"] = 4] = "Loading";
})(ListBoxItemType || (ListBoxItemType = {}));
